<template>
  <div style="position:relative; width:100%; padding:0" id="liveSkyContainer">
    <div class="skychart abs" id="chart">
      <SkyChart
        v-bind:darkMode="true"
        v-bind:satMagLimit="parseFloat(settings.magLimit)"
        v-bind:elevLimit="parseFloat(settings.elevLimit)"
        v-bind:showSatLabels="settings.showSatLabels"
        v-bind:showAsterisms="settings.showAsterisms"
        v-bind:showStarLabels="settings.showStarLabels"
        v-bind:showConstellationBoundaries="settings.showConstellationBoundaries"
        v-bind:showConstellationLabels="settings.showConstellationLabels"
        v-bind:showEcliptic="settings.showEcliptic"
        v-bind:showEquator="settings.showEquator"
        v-bind:showSkyShading="settings.showSkyShading"
        v-bind:comets="comets"
        culture="de"
      />
    </div>
    <div id="infoContainer" class="abs">
      <div id="satInfo">
        <satellite-popup v-bind:satData="selectedSat" />
      </div>
      <div id="satListContainer">
        <b-card no-body class="text-light text-center" header-tag="header">
          <template v-slot:header>{{ strings['currently.visible.satellites'] }}</template>
          <div class="sat-list" id="satList">
            <visible-satellite-list class="text-left" />
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import SkyChart from "./SkyChart.vue";
import SatellitePopup from "./SatellitePopup.vue";
import VisibleSatelliteList from "./VisibleSatelliteList";
import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import { mapState } from "vuex";
import axios from "axios";

Vue.use(Vuex);
Vue.use(VueRouter);

export default {
  name: "LiveSkyPage",
  components: {
    SkyChart,
    SatellitePopup,
    VisibleSatelliteList
  },

  computed: mapState(["selectedSat", "settings", "strings"]),

  mounted() {
    // event listeners
    let self = this;
    window.addEventListener(
      "resize",
      function() {
        // perform layout
        self.layout();
      },
      false
    );
    this.layout();

       // see if comets are available
    if (!this.comets) {
          axios
        .post("https://heavens-above.com/api2/graphql", {
          query: `
            query comets {
              comets(magLimit: 6) {
                id
                name
                currentMagnitude
                lastObservationTime
                astrometricPosition {
                  rightAscension
                  declination
                  x y z
              }
            }
          }`,
          variables: null,
          operationName: "comets"
        })
        .then(response => {
          this.comets = response.data.data.comets;
        })
        .catch(error => {
          console.log(error);
        });
    
    }
  },
  methods: {
    layout: function() {
      const width = document.getElementById("liveSkyContainer").clientWidth;
      const height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

      let skyChart = document.getElementById("chart");
      let satList = document.getElementById("satListContainer");
      let satInfo = document.getElementById("satInfo");
      let infoContainer = document.getElementById("infoContainer");

      let chartStyle, listStyle, infoStyle, infoContainerStyle;
      let midPadding = 20;

      if (width > height) {
        // put text info on left
        let textMinWidth = 300;
        let textMaxWidth = 500;
        let chartWidth = Math.min(height, width - textMinWidth - midPadding);
        let textWidth = Math.min(width - chartWidth - midPadding, textMaxWidth);
        let chartHeight = chartWidth;
        //let listHeight = 300;
        // let infoHeight = 400;
        let chartLeft = 0;
        let infoLeft = chartWidth + midPadding;
        let surplus = width - chartWidth - textWidth - midPadding;
        if (surplus > 0) {
          // center components
          chartLeft = surplus / 2;
          infoLeft += surplus / 2;
        }

        chartStyle = "left:" + chartLeft + "px;width:" + chartWidth + "px;height:" + chartHeight + "px";
        infoContainerStyle = "left:" + infoLeft + "px;top:0px;width:" + textWidth + "px";
        infoStyle = "left:0px;top:0;width:100%";
        listStyle = "left:0px;top:300px;width:100%;margin-top:20px";
      } else {
        // put text info at bottom
        let chartWidth = width;
        let chartHeight = chartWidth;
        let textWidth = (width - midPadding) / 2;
        chartStyle = "width:" + chartWidth + "px;height:" + chartHeight + "px";
        infoContainerStyle =
          "left:0;top:" +
          (chartHeight + midPadding) +
          "px;width:" +
          (textWidth * 2 + midPadding) +
          "px";
        infoStyle = "position:absolute;left:0;top:0;width:" + textWidth + "px";
        listStyle = "position:absolute;right:0;top:0;width:" + textWidth + "px";
      }

      skyChart.setAttribute("style", chartStyle);
      satList.setAttribute("style", listStyle);
      infoContainer.setAttribute("style", infoContainerStyle);
      satInfo.setAttribute("style", infoStyle);
    }
  },
  data() {
    return {
      //showSats: false
      comets: null
    };
  }
};
</script>

<style>
/*.sat-list {
  overflow-y: auto;
  display: block;
  height: 550px;
}
*/
.rel {
  position: relative;
}
.abs {
  position: absolute;
}
</style>
